import React, { useState } from 'react';
import { Card, Form, Button, InputGroup, Spinner } from 'react-bootstrap';
import ApiGSenha from 'services/ApiGSenha';

const Form5 = ({ serial }) => {
  const [hash, setHash] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  const gerarHash = async (serial) => {
    const { data } = await ApiGSenha.post('/api/generate-hash7', { serial });
    return data;
  };

  const handleGerar = async () => {
    try {
      setLoading(true);
      setError('');
      setCopied(false);
      const generatedHash = await gerarHash(serial);
      console.log(generatedHash);
      setHash(`#F3${generatedHash.hash}`);
    } catch (err) {
      console.error('Erro ao gerar hash:', err);
      setError('Erro ao gerar hash');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(hash);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  return (
    <Card className="mb-3 mt-3">
      <Card.Header>
        <h5 className='mt-2 mb-2'>Senha para desbloquear rede</h5>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Senha Gerada</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="A senha será exibida aqui"
                value={hash}
                readOnly
              />
              {!hash ? (
                <Button
                  variant="primary"
                  onClick={handleGerar}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Gerando...
                    </>
                  ) : (
                    'Gerar Hash'
                  )}
                </Button>
              ) : (
                <Button
                  variant={copied ? "success" : "secondary"}
                  onClick={handleCopy}
                >
                  {copied ? 'Copiado!' : 'Copiar'}
                </Button>
              )}
            </InputGroup>
            {error && <Form.Text className="text-danger">{error}</Form.Text>}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default Form5;
